function RoundedCheckIcon(props) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="8.00348" cy="8.00323" r="6.0025" fill="white" />
      <path
        d="M11.5034 6.00391L6.77615 9.54936L5.00342 7.42209"
        stroke="#00722A"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
export default RoundedCheckIcon;
